import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../constants/routerUrl";
import { useState } from "react";
import { connect } from "react-redux";
import { logoutUser } from "../../action/common/keyClaokActionCreator";
import { IUserInfo } from "../../models/common/IUserProfile";

const StaffMenu = (props: IUserInfo) => {
  const [] = useState(ROUTER_URL.STAFF_DASHBOARD);
  const { user, logout } = props;
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <ul className="accordion-menu">
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.STAFF_DASHBOARD}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/dashboard.svg" alt="" /> Dashboard
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.RESOURCES}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/teacher.svg" alt="" />
            Resources
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.STAFF_TRAINING}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/book.svg" alt="" />
            Employee Training
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.STAFF_REPORTS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/chart-bar.svg" alt="" />
            Reports
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.STAFF_CONNECT}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/call.svg" alt="" />
            Communication
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.NOTIFICATION}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/bell.svg" alt="" />
            Notifications
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.FEEDBACK}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/feedback.svg" alt="" />
            Feedback
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.SETTINGS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/setting.svg" alt="" />
            Settings
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.INSTRUCTIONS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/help.svg" alt="" /> Help
          </NavLink>
        </li>
      </ul>
      <div className="poweredby">
        <a
          href="https://www.buduportal.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/assets/images/budu.png" alt="" />
          Powered by Budu Portal
        </a>
        <p className="version">Version 2.0.0</p>
        <p className="copyrights">
          &copy; 2025 Budu Portal. All rights reserved.
        </p>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  logout: () => logoutUser(),
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
    user: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffMenu);
